import {
  Component,
  Inject,
  makeStateKey,
  TransferState,
  AfterViewInit,
  PLATFORM_ID,
  Renderer2,
} from "@angular/core";
import { DOCUMENT, isPlatformBrowser } from "@angular/common";
import { MktBrandingService } from "./common/services/mkt-branding.service";

const IS_SHOWHEADER_KEY = makeStateKey<boolean>('showHeader');
const CLASS_CDS = 'cbolui-cds';
const CLASS_DDL = 'cbolui-ddl';

@Component({
  selector: "app-root",
  templateUrl: "./app.component.html",
  standalone: false,
})
export class AppComponent implements AfterViewInit {
  public showHeader: boolean;
  public isBrowser: boolean;

  constructor(
    private _branding: MktBrandingService,
    private _transferState: TransferState,
    private renderer: Renderer2,
    @Inject(DOCUMENT) private _document: Document,
    @Inject(PLATFORM_ID) private platformId: Object
  ) {
    this.showHeader = this._transferState.get(IS_SHOWHEADER_KEY, null);
  }
  
  ngAfterViewInit(): void {
    if(this.showHeader){
      this._branding.showHeaderFooter();
      this.deferBodyClassUpdate();
    }

    // if (isPlatformBrowser(this.platformId)) {
    //     const transferStateElement = this.renderer.selectRootElement('#citi-universal-state', true);
    //     if (transferStateElement) {
    //         this.renderer.removeChild(transferStateElement.parentNode, transferStateElement);
    //     }
    // }
  }
  /**
   * Defers the body class update to avoid blocking rendering.
   */
  private deferBodyClassUpdate() {
      const className = !this.showHeader ? CLASS_DDL : CLASS_CDS;
      this._document?.body?.classList.add(className);
      if (!this.showHeader) {
        this._document?.querySelector('.citi-outer-container')?.classList?.remove('cbolui-ddl-post');
      }
  }
}
